import React from 'react';
import { Navigation } from '../components/Navigation';
import { HeroSection } from '../components/HeroSection';
import { WelcomeSection } from '../components/WelcomeSection';
import { OfferingsSection } from '../components/OfferingsSection';
import { ReviewsSection } from '../components/ReviewsSection';
import { AboutSection } from '../components/AboutSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export function LandingPage() {
  return <div className="min-h-screen bg-night-900 text-cream-50 font-sans selection:bg-gold-400 selection:text-night-900" data-id="element-165">
      <Navigation data-id="element-166" />
      <main data-id="element-167">
        <HeroSection data-id="element-168" />
        <WelcomeSection data-id="element-169" />
        <OfferingsSection data-id="element-170" />
        <ReviewsSection data-id="element-171" />
        <AboutSection data-id="element-172" />
        <ContactSection data-id="element-173" />
      </main>
      <Footer data-id="element-174" />
    </div>;
}